import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''
export const getTree = async ({ token, language }) => {
  try {
    return await clientPublic
      .get(`supporttype/tree?lang=${language}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeV2 = async ({ token, language }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/support-category/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getTable = async ({ token, company_id }) => {
  try {
    return await clientPublic
      .get(`supporttype?company_id=${company_id}&limit=9999999`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getResultCompany = async ({ token }) => {
  try {
    return await clientPublic
      .get('company', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultCompanyV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .get('/core/management/company/dropdown', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const postData = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`supporttype`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const updateData = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`supporttype/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const deleteDataSupportCategory = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .delete(`supporttype/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
